module.exports = __webpack_public_path__ + "static/media/dropdown.73bcca67.svg";